import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import MobileMenuNavButton from '../atoms/MobileMenuNavButton';
import { Tile } from '../../../types';
import HeaderDropdownTile from '../../header-navigation-desktop/menu-dropdown/header-menu-tile';
import MobileMenuContentLevel2 from './MobileMenuContentLevel2';

export interface Props {
  links: Category[];
  hideHeaderMenu: () => void;
  categoriesNavigator: Category[]; //This is a navigator where you push a descendant to show it's contents
  insertCategory: (category: Category) => void;
  tileContent?: Tile[];
}

const MobileMenuContent: React.FC<Props> = ({
  links,
  categoriesNavigator,
  insertCategory,
  hideHeaderMenu,
  tileContent,
}) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="overflow-auto px-5 pb-5">
      {categoriesNavigator &&
        categoriesNavigator?.length > 0 &&
        categoriesNavigator[categoriesNavigator.length - 1]?.categoryId != 'myAccount' && (
          <Link
            onClick={hideHeaderMenu}
            link={
              categoriesNavigator[categoriesNavigator.length - 1]?._url ??
              categoriesNavigator[categoriesNavigator.length - 1]?.slug
            }
            className="mb-5 block"
          >
            <Typography as="span" className="italic">
              {formatMessage({ id: 'common.viewAll', defaultMessage: 'Visualizza tutto' })}
            </Typography>
          </Link>
        )}
      {categoriesNavigator && categoriesNavigator.length <= 0 ? (
        links?.map((link) => (
          <MobileMenuNavButton
            key={link.categoryId}
            link={link}
            onClick={() => insertCategory(link)}
            hideHeaderMenu={hideHeaderMenu}
          />
        ))
      ) : (
        <MobileMenuContentLevel2
          categories={categoriesNavigator[categoriesNavigator.length - 1].descendants || []}
          hideHeaderMenu={hideHeaderMenu}
          insertCategory={insertCategory}
        />
      )}
      <div className="mt-20 flex justify-between gap-2">
        {tileContent?.map(
          // (x, i) => x.tileCategoryKey === categoryKey && <HeaderDropdownTile key={i} tileContent={x} />,
          (x, i) => <HeaderDropdownTile key={i} tileContent={x} />,
        )}
      </div>
    </div>
  );
};

export default MobileMenuContent;
